import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { voyageGameStatus_enemyShips } from '../voyageGameStatus_enemyShips-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageMessage } from './voyageMessageIds'
import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'

export interface IMessageEnemyShipCommand {
  command: EVoyageEnemyShipCommand
  type?: EVoyageEnemyShipType
}

export enum EVoyageEnemyShipType {
  Hammerhead = 0,
}
export enum EVoyageEnemyShipCommand {
  Create = 0,
  Destroy = 1,
}

export const voyageMessageId = EVoyageMessage.EnemyShipCommand

export function write(m: IMessageWriter, d: IMessageEnemyShipCommand) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write8(m, d.command)
  messageWriter.write8(m, d.type || 0)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IMessageEnemyShipCommand = {
    command: messageWriter.read8(m),
    type: messageWriter.read8(m),
  }

  return d
}

export function test() {
  let ex: IMessageEnemyShipCommand = {
    command: EVoyageEnemyShipCommand.Destroy,
    type: EVoyageEnemyShipType.Hammerhead,
  }
  messageWriter.test('enemy-ship-command', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)

  if (msg.command === EVoyageEnemyShipCommand.Destroy) {
    voyageGameStatus_enemyShips.networkDestroy(msg)
  }
  if (msg.command === EVoyageEnemyShipCommand.Create) {
    voyageGameStatus_enemyShips.createHammerheadClass()
  }

  //
}

export function sendMessageAndImmediatelyExecute(
  msg: IMessageEnemyShipCommand,
) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
